export const notesAndImagesVisibilityValues = {
  hidden: 'hidden',
  visible: 'visible',
}

export const notesAndImagesVisibilityOptions = [
  {
    label: 'No compartir notas e imágenes con los clientes',
    value: notesAndImagesVisibilityValues.hidden,
  },
  {
    label: 'Mostrar notas e imágenes de rechazo con los clientes en panel y comunicaciones',
    value: notesAndImagesVisibilityValues.visible,
  },
]
